import { render, staticRenderFns } from "./search-form.vue?vue&type=template&id=f162a0fc&scoped=true&"
import script from "./search-form.vue?vue&type=script&lang=ts&"
export * from "./search-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f162a0fc",
  null
  
)

export default component.exports